var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fade-transition',[(_vm.hover || _vm.showTooltip)?_c('div',{staticClass:"d-flex transition-fast-in-fast-out text-center ar-tooltip habiteo-body-2",class:{
            'pr-4': !_vm.$vuetify.breakpoint.xsOnly,
            'offset px-2': _vm.$vuetify.breakpoint.xsOnly
        }},[_c('span',[_vm._v("\n            "+_vm._s(_vm.$t('augmentedReality.tooltips.info'))+"\n        ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1944c4f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/augmentedReality/components/ArTooltip.vue
// module id = null
// module chunks = 